import React, { useState } from "react";
import { useRound } from "context/roundContext";
import SkeletonLoader from "components/skeletonLoader";
import { useTranslation } from "react-i18next";
import RoundEvents from "views/userLeague/rounds/roundContent/eventList";
import { useRoundData } from "hooks/useRoundData";
import LmsUserPicks from "components/lmsUserPick";
import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import { classNames } from "utils/utils";

const LmsTabs = () => {
  const {
    state: { isLoading, currentRound, userRoundData },
  } = useRound();
  const { t } = useTranslation();
  let roundStarted =
    new Date(currentRound?.deadline?.seconds * 1000) < new Date() ||
    currentRound?.settled;
  const [tab, setTab] = useState(roundStarted ? 0 : 1);

  const setTabHandler = (event) => {
    setTab(event.detail.value);
  };

  if (isLoading) {
    return <SkeletonLoader type={"eventCard2"} amount={3} />;
  }
  return (
    <>
      <IonSegment
        mode="ios"
        value={tab}
        onIonChange={setTabHandler}
        className={classNames(!roundStarted && "hidden")}
      >
        <IonSegmentButton value={0}>
          <IonLabel>By team</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value={1}>
          <IonLabel>By event</IonLabel>
        </IonSegmentButton>
      </IonSegment>
      {tab == 0 ? (
        <div className="flex flex-col space-y-3 pt-2">
          <LmsUserPicks />
        </div>
      ) : (
        tab == 1 && (
          <>
            {roundStarted && (
              <div className="flex uppercase tracking-wide text-xs text-textPrimary w-full justify-end px-2 pt-2">
                {t("tournament.events.distribution")}
              </div>
            )}
            <div className="flex flex-col space-y-3">
              <RoundEvents key={userRoundData.id} />
            </div>
          </>
        )
      )}
    </>
  );
};

export default LmsTabs;
